
      const GA_ID = import.meta.env.VITE_GA_ID;
      if (GA_ID) {
        const s = document.createElement("script");
        s.async = true;
        s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
        document.head.appendChild(s);

        // 等待腳本載入後再設定 config
        s.onload = () => {
          window.gtag("config", GA_ID, { send_page_view: false }); // SPA 關閉自動頁面瀏覽
        };
      }
    